import { api } from "./api";

/**
 * Thin wrapper over the booking-chat endpoints: same shape for staff
 * (`/bookings/:id/chat`) and customer (`/customer/bookings/:id/chat`)
 * callers, differing only in base path. Both use the same shared `api`
 * axios instance (one bearer token in localStorage regardless of account
 * type), so no separate client is needed.
 */
function basePath(viewerType, bookingId) {
  return viewerType === "customer"
    ? `/customer/bookings/${bookingId}/chat`
    : `/bookings/${bookingId}/chat`;
}

export async function getChat(viewerType, bookingId) {
  const r = await api.get(basePath(viewerType, bookingId));
  return r.data;
}

export async function postChatMessage(viewerType, bookingId, { text, attachmentIds = [] }) {
  const r = await api.post(`${basePath(viewerType, bookingId)}/messages`, {
    text, attachment_ids: attachmentIds,
  });
  return r.data;
}

export async function markChatRead(viewerType, bookingId) {
  await api.post(`${basePath(viewerType, bookingId)}/read`);
}

export async function uploadChatAttachment(viewerType, bookingId, { filename, contentType, dataBase64 }) {
  const r = await api.post(`${basePath(viewerType, bookingId)}/attachments`, {
    filename, content_type: contentType, data_base64: dataBase64,
  });
  return r.data;
}

export async function getChatAttachmentData(viewerType, bookingId, attachmentId) {
  const r = await api.get(`${basePath(viewerType, bookingId)}/attachments/${attachmentId}/data`);
  return r.data;
}
